import { parseOptionalNonNegativeNumber } from '../../parse-optional-non-negative-number.js';
import { PART_CONSTRAINTS } from './constraints.js';
import { partPhysicalEditFormSchema } from './physical-form.js';
export const PART_PHYSICAL_FORM_FIELD_KEYS = Object.keys(partPhysicalEditFormSchema.shape);
export function toUpdatePartInputFromPhysicalForm(values, dirtyFields) {
    const parsed = partPhysicalEditFormSchema.parse(values);
    const input = {};
    if (dirtyFields.weight) {
        const weight = parseOptionalNonNegativeNumber(parsed.weight, PART_CONSTRAINTS.weight.label);
        input.weight = typeof weight === 'number' ? weight : null;
    }
    if (dirtyFields.weightUomId)
        input.weightUomId = parsed.weightUomId || null;
    if (dirtyFields.len) {
        const len = parseOptionalNonNegativeNumber(parsed.len, PART_CONSTRAINTS.len.label);
        input.len = typeof len === 'number' ? len : null;
    }
    if (dirtyFields.width) {
        const width = parseOptionalNonNegativeNumber(parsed.width, PART_CONSTRAINTS.width.label);
        input.width = typeof width === 'number' ? width : null;
    }
    if (dirtyFields.height) {
        const height = parseOptionalNonNegativeNumber(parsed.height, PART_CONSTRAINTS.height.label);
        input.height = typeof height === 'number' ? height : null;
    }
    if (dirtyFields.sizeUomId)
        input.sizeUomId = parsed.sizeUomId || null;
    return input;
}
//# sourceMappingURL=physical-mapper.js.map